import React, { useEffect, useState } from 'react';
import ReactEcharts from 'echarts-for-react';
import API from '../../../api';

const StatBonAvoir= () => {
    const [etatFacturationValues, setEtatFacturationValues] = useState({
        totalBonAvoirPercentage: 0,
        totalFact: 0,
        total_facture_direct: 0,
    });

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await API.post('bon/avoir/client/get_stat');
                const data = response.data.BonAvoirClient[0];
                setEtatFacturationValues({
                    totalBonAvoirPercentage: parseFloat(data.totalBonAvoirPercentage),
                    totalFact: parseFloat(data.totalFact),
                    total_facture_direct: parseFloat(data.total_facture_direct),
                });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        fetchData();
    }, []);

    const getOptionFacturation = () => {
        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b}: {c} ({d}%)",
            },
            legend: {
                orient: "vertical",
                x: "left",
                data: ["Bon Avoir", "Total des factures"], // Updated legend names
                textStyle: {
                    color: ["#74788d"],
                },
            },
            color: ["#02a499", "#f8b425", "#ec4561", "#38a4f8", "#3c4ccf"],
            series: [
                {
                    name: "Total sales",
                    type: "pie",
                    radius: ["50%", "70%"],
                    avoidLabelOverlap: false,
                    label: {
                        normal: {
                            show: false,
                            position: "center",
                        },
                        emphasis: {
                            show: true,
                            textStyle: {
                                fontSize: "30",
                                fontWeight: "bold",
                            },
                        },
                    },
                    labelLine: {
                        normal: {
                            show: false,
                        },
                    },
                    data: [
                        { value: etatFacturationValues.totalBonAvoirPercentage, name: 'Bon Avoir' },
                        { value: etatFacturationValues.totalFact - etatFacturationValues.totalBonAvoirPercentage, name: 'Total des factures' },
                    ],
                },
            ],
        };
    };

    return (
        <React.Fragment>
            <p>Bon Avoir</p>
            <ReactEcharts style={{ height: '350px' }} option={getOptionFacturation()} />
        </React.Fragment>
    );
};

export default StatBonAvoir;
